import { muiStyles } from 'utils/design';

export const useStyles = muiStyles(() => ({
  labelContainer: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
